import { ReactNode } from 'react';

interface MainLayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: MainLayoutProps) => {
  return <>{children}</>;
};
